export default function SetAssetLocationModalController(
	$scope,
	$uibModalInstance,
	$state,
	gettextCatalog,
	isAssetLocationConfirmed,
	pinnedAssetModel,
	pinnedAssetEvent
) {
    'ngInject';

	$scope.pinnedAssetEvent = pinnedAssetEvent;
	$scope.isAssetLocationConfirmed = isAssetLocationConfirmed;

	$scope.pinnedAssetModel = {
		event: pinnedAssetEvent,
		isConfirmed: $scope.isAssetLocationConfirmed
	};

	$scope.ok = function() {
		$scope.pinnedAssetModel.isConfirmed = true;
		$uibModalInstance.close($scope.pinnedAssetModel);
	};

	$scope.cancel = function() {
		$scope.pinnedAssetModel.isConfirmed = false;
		$uibModalInstance.close($scope.pinnedAssetModel);
	};

	$scope.$on('$locationChangeStart', function(event) {
		$scope.cancel();
		event.preventDefault();
	});
}
